import { Fade } from "@mui/material";
import { config } from "env-config";
import { useEffect, FC } from "react";
import styled from "styled-components";

interface TitleProps {
  children: React.ReactNode;
  title?: string;
}

const Title: FC<TitleProps> = ({ children, title }) => {
  useEffect(() => {
    document.title = `${title || ""} | ${config.siteName}`;
  }, [title]);

  return <>{children}</>;
};

export default Title;
